import React from 'react';

const PerformanceSegments = () => {
  const multiFlight = 'multiFlight';
  return <p>{multiFlight}</p>;
};

export default PerformanceSegments;



// WEBPACK FOOTER //
// ./modules/OnTimePerformance/components/children/MultiFlight/container.js